export const LOAD = 'ethstats/gasLimit/LOAD';
export const LOAD_SUCCESS = 'ethstats/gasLimit/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/gasLimit/LOAD_FAIL';
